<template>
  <div class="overflow-hidden">
    <q-btn :style="{ backgroundColor: innerValue, color: computedForecolor }">
      {{computedColorText}}<br>{{innerValue}}
      <q-popup-proxy transition-show="flip-up" transition-hide="flip-down">
        <q-color v-model="innerValue" @change="onChange($event)" class="color-picker" />
      </q-popup-proxy>
    </q-btn>
  </div>
</template>

<script>
import { ThemeColor, ThemeColorCategory } from '@/lib/enums'
import { colors } from 'quasar'
import utils from '@/lib/utils'
import _ from 'lodash'

export default {
  data () {
    return {
      innerValue: null
    }
  },
  props: {
    color: {
      type: Number,
      require: true
    },
    colorVersion: Number
  },
  computed: {
    computedColor () {
      ((cv) => {})(this.colorVersion)
      const colorItem = ThemeColor.getItem(this.color)
      return colorItem && {
        id: colorItem.value,
        name: colorItem.name,
        kebabName: _.kebabCase(colorItem.name),
        text: colorItem.text,
        category: colorItem.meta?.category,
        initColor: colorItem.meta?.color
      }
    },
    computedColorValue () {
      const color = this.computedColor
      return color && (color.category === ThemeColorCategory.Brand ? colors.getBrand(color.kebabName) : utils.getThemeColor(color.kebabName))
    },
    computedColorText () {
      return this.computedColor?.text
    },
    computedForecolor () {
      return colors.brightness(this.innerValue) < 128 ? 'white' : 'black'
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  watch: {
    computedColorValue: {
      immediate: true,
      handler (val) {
        this.innerValue = val
      }
    }
  },
  methods: {
    onChange (value) {
      this.setColorValue(value)
      this.$emit('change', value)
    },
    setColorValue (value) {
      const color = this.computedColor
      if (color) {
        if (color.category === ThemeColorCategory.Brand) {
          colors.setBrand(color.kebabName, value)
        } else {
          utils.setThemeColor(color.kebabName, value)
        }
      }
    }
  }
}

</script>

<style lang="scss" scoped>
.color-picker {
  width: 300px;
}
</style>
